import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAMES } from '@/constants';

export interface IUserAvatarState {
    photoContent: string | null;
}

const initialState: IUserAvatarState = {
    photoContent: null,
};

export const UserAvatarSlice = createSlice({
    name: SLICE_NAMES.USER_AVATAR,
    initialState,
    reducers: {
        setAvatar: (state, action: PayloadAction<IUserAvatarState>) => {
            state.photoContent = action.payload.photoContent;
        },
        clearAvatar: (state) => {
            state.photoContent = null;
        },
    },
});

export const { setAvatar, clearAvatar } = UserAvatarSlice.actions;

export default UserAvatarSlice.reducer;
